module.exports = "/images/en.png?f5a44c2aab33840669c4498d699ef666";